<button class="toolbar-btn" [ngClass]="buttonClass" title="{{title}}"><ng-content></ng-content></button>
